import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from 'src/hooks/AuthHook';
import { AcceptInvitationPage } from 'src/pages/AcceptInvitationPage';
import { ForgotPasswordPage } from 'src/pages/ForgotPasswordPage';
import { LoginPage } from 'src/pages/LoginPage';
import ReconfirmAccountPage from 'src/pages/ReconfirmAccountPage/ReconfirmAccountPage';
import { ResetPasswordPage } from 'src/pages/ResetPasswordPage';
import { TwoFactorSetupPage } from 'src/pages/TwoFactorSetupPage';
import { TwoFactorVerifyPage } from 'src/pages/TwoFactorVerifyPage';

export const RoutesManagerPublic = observer(function (): React.JSX.Element {
  const { user: { email } = {} } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if user logged in (but allow 2FA setup page for logged-in users)
  useEffect(() => {
    let inPage = true;
    const is2FAPage = location.pathname === '/auth/setup-2fa';

    if (email && inPage && !is2FAPage) {
      navigate('/dashboard', { replace: true });
    }

    return () => {
      inPage = false;
    };
  }, [email, navigate, location.pathname]);

  return (
    <Routes>
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/auth/invitation" element={<AcceptInvitationPage />} />
      <Route path="/auth/confirmation" element={<ReconfirmAccountPage />} />
      <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
      <Route path="/auth/verify-2fa" element={<TwoFactorVerifyPage />} />
      <Route path="/auth/setup-2fa" element={<TwoFactorSetupPage />} />
      <Route path="/*" element={<LoginPage />} />
    </Routes>
  );
});
